import { Component, Input, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, Output, ElementRef, Inject } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {SlideshowService} from '../slideshow.service';
import {ImagesService} from '../../shared/images.service';
import {Utils} from '../../utils';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PermissionsService } from '../../shared/permissions.service';
import { Permissions } from '../../shared/permissions.enum';

@Component({
    selector: 'slide-component',
    templateUrl: 'slide.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlideComponent {
    canEdit = false;
    tempImageGroupIds = [];
    slideTeaser = this.utils.rand();
    slideMetaTitle = this.utils.rand();
    viewInit = new EventEmitter();

    @Input() slide;
    @Input() i;
    @Input() caption; // this triggers a caption change from parent

    @Output() resultsChanged = new EventEmitter();

    public get Permissions(): typeof Permissions {
        return Permissions; 
    }

    constructor(
        public cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private images: ImagesService, 
        private route: ActivatedRoute,
        public slideshow: SlideshowService,
        public utils: Utils,
        public ref: ElementRef,
        public permissionsService: PermissionsService,
    ) {
        this.slideshow.slidesLoaded.subscribe(index => {
            let segments = this.route.snapshot['_urlSegment'].segments;
            if( segments.length == 3 ) {
                let slideIndex = parseInt(segments[2].path);
                this.slideshow.setSlide(slideIndex);
            }
        });
        this.slideshow.slideOrderChange.subscribe(() => {
            this.cdr.markForCheck();
        });
        this.slideshow._locked.subscribe(() => {
            this.cdr.markForCheck();
        });
        this.slideshow.featuredImageChange.subscribe(() => {
            this.cdr.markForCheck();
        });
        this.images.imagesChange.subscribe(() => {
            this.cdr.markForCheck();
        });
    }
    ngAfterViewInit() {
        this.viewInit.emit(this.slide);
    }
    getContent(content) {
        let html = '';
        if( Array.isArray(content) ) {
            const texts = [];
            content.forEach(item => {
                texts.push('<p>' + item.text + '</p>');
            });
            html = texts.join('');
        } else {
            return '<span>' + content + '</span>';
        }
        return html;
    }
    addContent(slide, i, index, content) {
        let nextIndex = index + 1;
        slide.content.splice(nextIndex, 0, content);
        this.moveFocus('#content-' + i + '-' + nextIndex);
    }
    removeContent(slide, i, index, remove) {
        if( slide.content[index].text == '' || remove ) {
           slide.content.splice(index, 1);
           let prevIndex = index - 1;
           this.moveFocus('#content-' + i + '-' + prevIndex);
        }        
    }
    moveFocus(selector) {
        setTimeout(() => {
            let richtext = document.querySelector(selector + ' .medium-editor-element') as HTMLElement;
            if( richtext ) {
                richtext.focus();
            }
        }, 150);
    }
    addResult(slide) {
        slide.content.push({text: '', title: '', level: ''});
        this.slideshow.calculateTiers();
        this.emitResults();
    }
    resetBuckets(resultIndex) {
        const slides = this.slideshow.slides;
        for(var i = 0; i < slides.length; i++) {
            const content = slides[i].content;
            for(var j = 0; j < content.length; j++) {
                if( content[j].bucket == resultIndex ) {
                    content[j].bucket = 0;
                }
            }
        }
    }
    emitResults() {
        this.resultsChanged.emit(this.slide);
    }
    removeResult(slide, i) {
        if( this.slideshow.assignment.quizType == 'personality' ) {
            this.resetBuckets(i);
            this.emitResults();
        }
        slide.content.splice(i, 1);
        this.slideshow.calculateTiers();
    }
    getScore(i) {
        let text = '';
        let tier = this.slideshow.tiers[i];
        if( tier ) {
            text = ' (' + tier.min + '-' + tier.max + ')';
        }
        return text;        
    }
    addToSearch(terms, i) {
        this.slideshow.slides[i].search = terms;
    }
    contentAdded(e, i) {
        let nextId = 'me' + (i + 1);
        setTimeout(() => {
            let nodes = document.getElementsByName(nextId);
            if( nodes.length ) {
                let el = nodes[0].parentElement.querySelector('.medium-editor-element') as HTMLElement;
                el.focus();
            }
        }, 50);
    }
    getWordCount(content) {
        let clean = this.slideshow.cleanContent;
        let str = '';
        for(var i = 0; i < content.length; i++) {
            let cleanStr = clean(content[i].text).trim();
            if( cleanStr !== '' ) {
                str += ' ' + cleanStr;
            }
        }
        return str != '' ? str.split(' ').length - 1 : 0;
    }
    toggle(item, slide) {
        slide[item] = !slide[item];
    }
    setQuizResultImage(e, content, i) {
        if( e.images.length == 0 ) {
            if( e.mobile ) {
                delete content[i].imageMobile;
            } else {
                delete content[i].image;
            }
        } else {
            if( e.mobile ) {
                content[i].imageMobile = e.images[0];
            } else {
                content[i].image = e.images[0]; 
            }
        }
        this.cdr.markForCheck();
    }
    showMlDialog(slideIndex: number) {
        const dialog = this.dialog.open(MlSlideDialog);
        dialog.afterClosed().subscribe(
            mlData => {
                if( !mlData ) {
                    return;
                }

                let titleChange;
                let contentChange;

                if (mlData.acceptedHeaderIndex > -1) {
                    titleChange = true;
                    if(slideIndex > 0) {
                        this.slide.headers = mlData.headerResponses[mlData.acceptedHeaderIndex];
                        this.slide.title = mlData.headerResponses[mlData.acceptedHeaderIndex][0];
                    } else {
                        this.slideshow.assignment.articleTitle = mlData.headerResponses[mlData.acceptedHeaderIndex][0];
                    }
                }

                if (mlData.acceptedParagraphIndex > -1) {
                    contentChange = true;
                    const contentParagraphs = mlData.paragraphResponse[mlData.acceptedParagraphIndex];
                    this.slide.content = [];
                    contentParagraphs.forEach(content => {
                        this.slide.content.push({
                            text: content
                        });
                    });

                    this.slideshow.slideContentChange.emit(this.slide);
                }

                if(titleChange && this.slideshow.assignment.metaTitle == '') {
                    this.slideshow.titleChange(this.slide);
                    if(slideIndex === 0) {
                        this.slideshow.assignment.metaTitle = this.slideshow.slides[0].metaTitle;
                    }
                }
                if(contentChange && this.slideshow.assignment.metaDescription == '') {
                    this.slideshow.updateMetaDescription(this.slide, this.slide.content.map(c => c.text).join("\n"));
                    if(slideIndex === 0) {
                        this.slideshow.assignment.metaDescription = this.slideshow.slides[0].metaDescription;
                    }
                }
                
                this.cdr.detectChanges();
            }
        );
    }
    maybeCreateMultipleSlides(slideStartPosition: number) {
        const dialog = this.dialog.open(CreateMultipleDialog);
        dialog.afterClosed().subscribe(numOfSlides => {
            const numSlides = Number.parseInt(numOfSlides);
            console.log(numSlides);
            if(Number.isNaN(numSlides)) return;
            this.slideshow.createMultipleSlides(slideStartPosition, numSlides);
        });
    }
    direct(content, index) {
        return (event) => {
            this.setQuizResultImage(event, content, index);
        }
    }
}

@Component({
    selector: 'ml-dialog',
    template: `
        <ml-prompt [data]="data" (dataChange)="data = $event"></ml-prompt>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [mat-dialog-close]="data">Insert</button>
        </mat-dialog-actions>`,
})
export class MlSlideDialog {
    data;
    constructor(private ref: MatDialogRef<MlSlideDialog>, @Inject(MAT_DIALOG_DATA) public inputData: any) {
        this.data = inputData || {};
    }
    send() {
        this.ref.close(this.data);
    }
}

@Component({
    selector: 'ml-error-dialog',
    template: `
        <h2 mat-dialog-title>Error</h2>
        <mat-dialog-content id="ml-error">
            <p>There was an error with the ML API. Please try again later.</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Close</button>
        </mat-dialog-actions>`,
})
export class MlSlideErrorDialog {
    constructor(private ref: MatDialogRef<MlSlideErrorDialog>) {}
}

@Component({
    selector: 'create-multiple-dialog',
    template: `
        <h2 mat-dialog-title>Create Multiple Slides</h2>
        <mat-dialog-content id="create-multi-request">
            <div class="input-wrap"><textarea placeholder="20" [(ngModel)]="slides" (keyup.enter)="send()"></textarea></div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [mat-dialog-close]="slides">Create</button>
        </mat-dialog-actions>`,
})
export class CreateMultipleDialog {
    slides = '';
    constructor(private ref: MatDialogRef<CreateMultipleDialog>) {}
    send() {
        this.ref.close(this.slides);
    }
}